import Info from '@components/Info';
import Section from '@components/Section';
import Button from '@components/UI/Button';
import Container from '@components/UI/Container';
import Picture from '@components/UI/Picture';
import Paragraph from '@components/UI/Typography/Paragraph';
import useUtmTags, { Utm } from '@hooks/useUtmTags';

import handShake from '@images/handshake.png';

import css from '@utils/css';
import Image from 'next/image';

import React from 'react';


const FeedbackBanner = () => (
  <Section
    mods={ { home: true } }
  >
    <Container>
      <Info
        mods={ { center: true } }
        className={ css('relative flex flex-col gap-4 justify-center text-center p-8 md:p-12 xl:p-16') }
      >
        <div
          className='absolute left-0 top-0 h-full w-full overflow-hidden -z-[1] rounded-16p'
        >
          <div
            className='radials radials_dark w-[1716px] h-[1716px]'
          >
          </div>
          <div
            className='radials radials_dark w-[960px] h-[960px]'
          >
          </div>
          <div
            className='radials radials_dark w-[600px] h-[600px]'
          >
          </div>
        </div>
        <h2
          className='heading heading_white h3 flex justify-center items-center gap-2.5'
        >
          <span>Let’s <span className={ 'text-violet-700' }>make science</span> together!</span>
          <Image
            src={ handShake }
            alt='Make science together'
            width={ 44 }
            height={ 44 }
          />
        </h2>
        <Paragraph
          color='white'
          mods={ {
            lg:true
          } }
          className='max-w-[568px]'
        >
                    Cooperation in science is essential for technological progress and understanding human behavior, ultimately enhancing our lives. The Traqq team is committed to scientific collaboration and eager to contribute to human resource management.
        </Paragraph>
        <div className={ css('flex flex-col gap-4 items-start justify-center') }>
          <Button
            tag='a'
            type='link'
            href={ useUtmTags('/contact?subject=Let%E2%80%99s%20make%20science%20together',
                { utm_campaign: Utm.CAMPAIGN.BANNER, utm_term: 'Collaborate with Traqq' }
            ) }
            variant='primary'
            size='lg'
            mods={ { 'no-spacing': true } }
            className={ 'self-center' }
          >
                        Collaborate with Traqq
          </Button>
        </div>
      </Info>
    </Container>
  </Section>
);

export default FeedbackBanner;
